// extracted by mini-css-extract-plugin
export var avatarContainer = "_9h-0";
export var avatarTypingWave = "_9h-i";
export var gray = "_9h-f";
export var green = "_9h-c";
export var icon = "_9h-9";
export var image = "_9h-1";
export var lg = "_9h-6";
export var md = "_9h-5";
export var presenceDot = "_9h-b";
export var red = "_9h-d";
export var sm = "_9h-4";
export var status = "_9h-a";
export var typingDot = "_9h-h";
export var typingPill = "_9h-g";
export var xl = "_9h-7";
export var xs = "_9h-3";
export var xxl = "_9h-8";
export var xxs = "_9h-2";
export var yellow = "_9h-e";